var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import Button from "antd/lib/button";
import Group from "@codex/components/Group";
import group1Img from "@codex/assets/images/group1.svg";
import group2Img from "@codex/assets/images/group2.svg";
import group3Img from "@codex/assets/images/group3.svg";
import group4Img from "@codex/assets/images/group4.svg";
import group1MobileImg from "@codex/assets/images/group1-mobile.svg";
import group2MobileImg from "@codex/assets/images/group2-mobile.svg";
import group3MobileImg from "@codex/assets/images/group3-mobile.svg";
import group4MobileImg from "@codex/assets/images/group4-mobile.svg";
import Layout from "@codex/containers/Layout";
import { Row } from "antd/lib/grid";
import { Col } from "antd/lib/grid";
import { AppContext } from "src/App";
import { store } from "@codex/store/index";
import { openDialog } from "@codex/app-ducks/actions";
import LoginForm from "../../components/LoginForm";
var Home = /** @class */ (function (_super) {
    __extends(Home, _super);
    function Home() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Home.prototype.componentDidMount = function () {
        document.title = "Codex";
    };
    Home.prototype.render = function () {
        var _a = this.props, classes = _a.classes, intl = _a.intl;
        return (React.createElement(Layout, null,
            React.createElement(Row, { type: "flex", justify: "center", align: "middle", className: classes.banner },
                React.createElement(Col, { span: 20, className: classes.bannerContent },
                    React.createElement(Row, { type: "flex", justify: "center", align: "middle" },
                        React.createElement("p", { className: classes.bannerHeadText }, intl.formatMessage({ id: "home.banner.title" }))),
                    React.createElement(Row, { type: "flex", justify: "center", align: "middle" },
                        React.createElement("p", { className: classes.bannerSubText }, intl.formatMessage({ id: "home.banner.subTitle" }))),
                    React.createElement(Row, null,
                        React.createElement(Button, { className: classes.headerButton, onClick: function () { return store.dispatch(openDialog({ Component: LoginForm })); } }, intl.formatMessage({ id: "home.banner.btnTxt" }))))),
            React.createElement(Row, { type: "flex", justify: "center", className: classes.groups },
                React.createElement(Col, { xs: 10, sm: 12, md: 6, lg: 6, xl: 5 },
                    React.createElement(AppContext.Consumer, null, function (_a) {
                        var isMobileScreen = _a.isMobileScreen;
                        return (React.createElement(Group, { image: isMobileScreen ? group1MobileImg : group1Img, title: intl.formatMessage({ id: "home.group1.title" }), subTitle: intl.formatMessage({ id: "home.group1.subTitle" }) }));
                    })),
                React.createElement(Col, { xs: 10, sm: 12, md: 6, lg: 6, xl: 5 },
                    React.createElement(AppContext.Consumer, null, function (_a) {
                        var isMobileScreen = _a.isMobileScreen;
                        return (React.createElement(Group, { image: isMobileScreen ? group2MobileImg : group2Img, title: intl.formatMessage({ id: "home.group2.title" }), subTitle: intl.formatMessage({ id: "home.group2.subTitle" }) }));
                    })),
                React.createElement(Col, { xs: 10, sm: 12, md: 6, lg: 6, xl: 5 },
                    React.createElement(AppContext.Consumer, null, function (_a) {
                        var isMobileScreen = _a.isMobileScreen;
                        return (React.createElement(Group, { image: isMobileScreen ? group3MobileImg : group3Img, title: intl.formatMessage({ id: "home.group3.title" }), subTitle: intl.formatMessage({ id: "home.group3.subTitle" }) }));
                    })),
                React.createElement(Col, { xs: 10, sm: 12, md: 6, lg: 6, xl: 5 },
                    React.createElement(AppContext.Consumer, null, function (_a) {
                        var isMobileScreen = _a.isMobileScreen;
                        return (React.createElement(Group, { image: isMobileScreen ? group4MobileImg : group4Img, title: intl.formatMessage({ id: "home.group4.title" }), subTitle: intl.formatMessage({ id: "home.group4.subTitle" }) }));
                    })))));
    };
    return Home;
}(Component));
export default Home;



//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/Home.tsx
// module id = 1350
// module chunks = 0